import React from 'react';
import { useData } from '../../contexts/DataContext';

const TestResults = () => {
  const { classes, exams, results } = useData();

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Test Results Debug</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold mb-2">Classes ({classes.length})</h3>
          <div className="space-y-2">
            {classes.slice(0, 5).map(cls => (
              <div key={cls.id} className="text-sm p-2 bg-gray-50 rounded">
                {cls.name} - {cls.studentCount} students
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold mb-2">Exams ({exams.length})</h3>
          <div className="space-y-2">
            {exams.slice(0, 5).map(exam => (
              <div key={exam.id} className="text-sm p-2 bg-gray-50 rounded">
                {exam.name} - {exam.className}
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold mb-2">Results ({results.length})</h3>
          <div className="space-y-2">
            {results.slice(0, 5).map(result => (
              <div key={result.id} className="text-sm p-2 bg-gray-50 rounded">
                {result.studentName} - {result.overallGrade}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestResults;
